import type { WhatsAppForwarding } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllWhatsAppForwardings = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    whatsappForwardings: WhatsAppForwarding[];
  }>(GET_ALL_WHATSAPP_FORWARDINGS, {
    variables: { tenantId },
    skip: !enabled,
  });

  return {
    whatsappForwardings: data?.whatsappForwardings ?? [],
    error,
    loading,
    refetch,
  };
};

export const GET_ALL_WHATSAPP_FORWARDINGS = gql`
  query GetAllWhatsAppForwardings($tenantId: String!) {
    whatsappForwardings(tenantId: $tenantId) {
      whatsappForwardingId
      phoneNumber
      name
      onboardingState
      createdAt
      updatedAt
    }
  }
`;
